import React from "react";

const styles = {
  ap: {
    fontFamily: "'Manrope', sans-serif",
    background: "#f4f4f9",
    width: "100%",
    padding: "60px 60px 0px",
    marginTop: "60px",
  },
  wrap: {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    color: "#4b5563",
  },
  hero: {
    textAlign: "center",
  },
  heroH1: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "2.8rem",
    color: "#000000",
    marginBottom: "12px",
    fontWeight: "700",
  },
  heroP: {
    fontSize: "1rem",
    lineHeight: "1.7",
    marginBottom: "6px",
  },
  h2: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "1.6rem",
    color: "#000000",
    margin: "16px 0 8px 0",
    fontWeight: "700",
  },
  p: {
    fontSize: "0.95rem",
    lineHeight: "1.7",
    marginBottom: "6px",
  },
  ul: {
    listStyle: "disc inside",
    marginLeft: "16px",
    marginBottom: "6px",
  },
  li: {
    fontSize: "0.95rem",
    lineHeight: "1.7",
  },
};

const sectionTitles = [
  "Introduction",
  "Eligibility",
  "Use of Platform",
  "Product & Service Information",
  "Pricing & Payments",
  "Order Acceptance & Cancellation",
  "Shipping & Delivery",
  "Returns & Refunds",
  "Intellectual Property",
  "Limitation of Liability",
  "User Conduct",
  "Privacy",
  "Governing Law & Jurisdiction",
  "Changes to Terms",
  "Contact Information",
];

const H2 = ({ n }) => (
  <h2 style={styles.h2}>{n}. {sectionTitles[n - 1]}</h2>
);

const TermsOfUsePage = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,700;1,400&family=Manrope:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <div className="row" style={styles.ap}>
        <div className="col-xl-12" style={styles.wrap}>

          {/* HERO */}
          <section style={styles.hero}>
            <h1 style={styles.heroH1}>Terms of Use</h1>
            <p style={styles.heroP}>Built on Trust. Grounded in Clarity.</p>
            <p style={styles.heroP}>
              Please read these Terms carefully before using our platform. By accessing or using Garshya, you agree to be bound by these Terms of Use, along with our policies on payments, shipping, returns, and privacy.
            </p>
          </section>

          {/* SECTIONS */}
          <section>

            <H2 n={1} />
            <p style={styles.p}>Garshya is an ecommerce marketplace founded in 2025 by <strong>Amit Choudhary</strong>, offering curated products and services across India.</p>
            <p style={styles.p}>These Terms govern your use of our website, services, and any transactions made through the platform, in accordance with applicable laws of India.</p>

            <H2 n={2} />
            <ul style={styles.ul}>
              <li style={styles.li}>You must be <strong>at least 18 years old</strong> or using the platform under supervision of a legal guardian</li>
              <li style={styles.li}>You agree to provide <strong>accurate and complete information</strong> during registration or checkout</li>
              <li style={styles.li}>You are responsible for maintaining the confidentiality of your account details</li>
            </ul>

            <H2 n={3} />
            <p style={styles.p}>By using Garshya, you agree:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>Not to misuse the platform for unlawful or fraudulent purposes</li>
              <li style={styles.li}>Not to interfere with website functionality or security</li>
              <li style={styles.li}>Not to attempt unauthorized access to data, systems, or accounts</li>
            </ul>
            <p style={styles.p}>Garshya reserves the right to <strong>restrict or terminate access</strong> for violations.</p>

            <H2 n={4} />
            <ul style={styles.ul}>
              <li style={styles.li}>We strive to ensure <strong>accurate descriptions, pricing, and availability</strong></li>
              <li style={styles.li}>Minor variations may occur due to display settings or supplier differences</li>
              <li style={styles.li}>We reserve the right to <strong>update or discontinue products/services</strong> without prior notice</li>
            </ul>

            <H2 n={5} />
            <ul style={styles.ul}>
              <li style={styles.li}>All prices are listed in <strong>Indian Rupees (INR)</strong> and are inclusive of applicable taxes unless stated otherwise</li>
              <li style={styles.li}>Payments must be completed through <strong>approved methods available on the platform</strong></li>
              <li style={styles.li}>Cash on Delivery (COD) is available with specific conditions, including <strong>advance payment requirements</strong></li>
            </ul>
            <p style={styles.p}>Garshya reserves the right to cancel orders in case of <strong>pricing errors, suspected fraud, or payment issues</strong>.</p>

            <H2 n={6} />
            <ul style={styles.ul}>
              <li style={styles.li}>Orders are confirmed only after successful payment or COD advance</li>
              <li style={styles.li}>We reserve the right to <strong>cancel or refuse orders</strong> due to product unavailability, logistical limitations, or suspicious activity</li>
            </ul>
            <p style={styles.p}>Customers may cancel orders as per our <strong>Cancellation Policy</strong>.</p>

            <H2 n={7} />
            <ul style={styles.ul}>
              <li style={styles.li}>Delivery timelines are <strong>estimated and may vary</strong> based on location and availability</li>
              <li style={styles.li}>Garshya is not liable for delays caused by external factors beyond our control</li>
            </ul>

            <H2 n={8} />
            <p style={styles.p}>Returns and refunds are governed by our <strong>Return &amp; Refund Policy</strong>, including eligibility, timelines, and conditions.</p>

            <H2 n={9} />
            <ul style={styles.ul}>
              <li style={styles.li}>All content on Garshya (logos, text, images, design) is the <strong>property of Garshya</strong></li>
              <li style={styles.li}>Unauthorized use, reproduction, or distribution is strictly prohibited</li>
            </ul>

            <H2 n={10} />
            <ul style={styles.ul}>
              <li style={styles.li}>Garshya shall not be liable for indirect or consequential damages, or loss of data, profit, or business interruption</li>
              <li style={styles.li}>Our liability is limited to the <strong>value of the order placed</strong></li>
            </ul>

            <H2 n={11} />
            <p style={styles.p}>You agree not to:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>Post false, misleading, or harmful information</li>
              <li style={styles.li}>Abuse, harass, or harm other users or the platform</li>
              <li style={styles.li}>Engage in activities that violate Indian laws or regulations</li>
            </ul>

            <H2 n={12} />
            <p style={styles.p}>Your personal data is handled in accordance with our <strong>Privacy Policy</strong>, ensuring responsible and secure usage of your information.</p>

            <H2 n={13} />
            <ul style={styles.ul}>
              <li style={styles.li}>These Terms are governed by the <strong>laws of India</strong></li>
              <li style={styles.li}>Any disputes shall be subject to the jurisdiction of courts located in <strong>[Your City/State]</strong></li>
            </ul>

            <H2 n={14} />
            <p style={styles.p}>Garshya reserves the right to update these Terms at any time. Continued use of the platform constitutes acceptance of the revised Terms.</p>

            <H2 n={15} />
            <p style={styles.p}>For any questions regarding these Terms, please contact us via our <strong>Contact Us</strong> page.</p>
            <p style={{ ...styles.p, marginTop: "16px", fontStyle: "italic" }}>
              Garshya is built on trust, clarity, and quality. These Terms ensure that experience remains consistent for everyone.
            </p>

          </section>
        </div>
      </div>
    </>
  );
};

export default TermsOfUsePage;